import { JobCreateRequest } from '../../requests/job/job.create.request';
import { JobTemplate, JobTemplateSummary } from './job.template';
import { v4 } from 'uuid';
import * as Enumerable from 'linq';
import { ActivityEntityName, EmbeddedCode } from '../shared';
import { JobTemplateCode } from './job.template.workorder';


export class JobTemplateUtility {

    public static toJobRequest(template: JobTemplate): JobCreateRequest {
        if (!template) return null;

        const job = template?.template;

        const request = {
            mode: template?.mode ?? 'Advanced',
            type: job?.type,
            priority: job?.priority,
            name: job?.name,
            description: job?.description,
            //If this has been specified on the template or recurring job, we should use it
            billingCompany: job?.company,
            priceBook: job?.priceBook,
            customFields: job?.customFields,
            labels: job?.labels,
            owner: job?.owner,
            fieldSupervisor: job?.fieldSupervisor,
            workOrders: job?.workOrders,
            templateName: template?.name,
            duration: job?.duration as any,

            startDate: null,
            endDate: null,
            dueDate: null,
            customer: {},
            updateCustomer: false,
            contact: {},
            address: null,
            technician: null,
            dispatch: false,
            createAppointment: false,
            usePrimaryContact: false,
            appointment: {},

            supervisor: null,
            quoteId: null,
            activity: null,
            placeId: null,
            quoteNumber: null,
            notifyTechnician: false,
            // keepQuotedSellPrice: false,
            codes: [],


        } as JobCreateRequest;

        if (!request.customFields) {
            request.customFields = {};
        }

        request.workOrders.forEach(item => {
            if (!item.customFields) {
                item.customFields = {};
            }
        })


        return request;

    }

    public static getDefaultTemplate(): JobTemplate {
        return {
            _id: null,
            name: null,
            description: null,
            mode: 'Advanced',
            templateMode: 'Static',
            templateEntity: ActivityEntityName.Job,
            public: false,
            template: {
                _id: v4(),
                workOrders: [
                    {
                        _id: v4(),
                        name: 'Default Stage',
                        codes: [],
                        customFields: null,
                        workCategory: null,
                    }
                ],
                questions: [],
                duration: null
            },

        };
    }

    public static getJobTemplateSummary(template: JobTemplate): JobTemplateSummary {

        const workOrders = template?.template?.workOrders ?? [];

        const summary = {
            _id: template._id,
            name: template.name,
            public: template.public,
            mode: template.mode,
            description: template.description,
            workOrderCount: workOrders.length ?? 0,
            priority: template?.template?.priority,
            codeCount: Enumerable.from(workOrders).selectMany(x => x?.codes).count(),
            templateMode: template.templateMode,
            templateEntity: template.templateEntity,

        } as JobTemplateSummary;

        return summary;
    }

    public static getJobTemplateCode(code: EmbeddedCode): JobTemplateCode {
        return {
            _id: code?._id,
            name: code?.name,
            quantity: code?.quantity,
            location: code?.location,
            description: code?.description,
            longDescription: code?.longDescription,
            canOverrideDesc: code?.canOverrideDesc,
            selected: false,
            category: code?.category,
            codeUoM: code?.codeUoM,
            buyPrice: code?.buyPrice,
            sellPrice: code?.sellPrice,
            customBuyPrice: code?.customBuyPrice,
            customSellPrice: code?.customSellPrice,
            note: code?.note,
            codeInvoicingStatus: code?.codeInvoicingStatus,
            suppliedBySubcontractor: code?.suppliedBySubcontractor,
            type: code?.type,
        }
    }

    public static getJobCode(x: EmbeddedCode) {

        const code = { ...x, sellPrice: x.adjustedSell, customSellPrice: true, customBuyPrice: x.customBuyPrice, adjustedSell: 0, totalAdjustment: 0, totalBuy: 0, totalSellEx: 0, totalSellInc: 0, totalTax: 0 } as EmbeddedCode;

        ['adjustedSell', 'totalAdjustment', 'totalBuy', 'totalSellEx', 'totalSellInc', 'totalTax']
            .forEach(field => delete code[field]);

        return code;
    }

}
